// extracted by mini-css-extract-plugin
export default {"container":"Rp-z","ratingLayout":"Sp-z","ratingLabel":"Tp-z","nonInteractiveRatingLabel":"Up-z"};